import { tv } from "../../variants/tv.js";
const sliderHistogramVariants = tv({
    slots: {
        container: 'flex h-15 items-end gap-[2px] px-3',
        barActive: 'min-h-[2px] flex-1 rounded-t-sm',
        barInactive: 'min-h-[2px] flex-1 rounded-t-sm'
    },
    variants: {
        emphasis: {
            regular: {
                barActive: 'bg-actionPrimary-7',
                barInactive: 'bg-primary-5'
            },
            medium: {
                barActive: 'bg-actionPrimary-7',
                barInactive: 'bg-primary-5'
            },
            bold: {
                barActive: 'bg-actionPrimary-7',
                barInactive: 'bg-primary-5/40'
            }
        }
    },
    defaultVariants: {
        emphasis: 'regular'
    }
});
export { sliderHistogramVariants };
